import { brandRFMSettingApi } from "../api/brandRFMSettingApi";
import {
  BrandRFMSetting,
  DefaultBrandRFMSetting,
} from "../models/brandRFMSetting";
import { getToken } from "../utils/getToken";

export const brandRFMSettingService = {
  getBrandRFMSettings: async (brandId: string): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandRFMSettingApi.getBrandRFMSettings(
          token,
          brandId
        );
        return response.data.result.BrandRFMSetting;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch brandId: ", error);
      return null;
    }
  },
  getDefaultBrandRFMSetting: async (
    brandId: string
  ): Promise<DefaultBrandRFMSetting | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandRFMSettingApi.getDefaultBrandRFMSetting(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error(
        "Failed to fetch default brand RFM Setting, brandId: ",
        error
      );
      return null;
    }
  },
  updateAllBrandRFMSetting: async (
    listBrandRFMSetting: BrandRFMSetting[]
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      const response = await brandRFMSettingApi.updateAllBrandRFMSetting(
        token,
        listBrandRFMSetting
      );
      return response.data.result.BrandRFMSetting;
    } catch (error) {
      console.error("Failed to Save Brand RFM Setting:", error);
      return null;
    }
  },
  resetBrandRFMSettings: async (brandId: string): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandRFMSettingApi.resetBrandRFMSetting(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to reset RFM Settings:", error);
      return null;
    }
  },
};
